import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = { class: "pb-10 pb-lg-15" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder d-flex align-items-center text-dark mb-10" }, " Recruitment Strategy ", -1)
const _hoisted_6 = { class: "fv-row mb-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Describe the recruitment strategies you will use for each group of subjects. ")
], -1)
const _hoisted_8 = { class: "fv-row" }
const _hoisted_9 = { class: "d-flex flex-stack" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Are subjects chosen from records?")
], -1)
const _hoisted_11 = { class: "form-check form-switch form-check-custom form-check-solid mb-7" }
const _hoisted_12 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_13 = { class: "fv-row mb-10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Who gave approval for use of the records? ")
], -1)
const _hoisted_15 = { class: "fv-row" }
const _hoisted_16 = { class: "d-flex flex-stack" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Do the records include any identifiable information? (e.g., name, address, etc.)")
], -1)
const _hoisted_18 = { class: "form-check form-switch form-check-custom form-check-solid mb-7" }
const _hoisted_19 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_20 = { class: "fv-row mb-10" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Please enter the identiable information ")
], -1)
const _hoisted_22 = { class: "fv-row" }
const _hoisted_23 = { class: "d-flex flex-stack" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Are the records publicly available (available to anyone to access)?")
], -1)
const _hoisted_25 = { class: "form-check form-switch form-check-custom form-check-solid mb-7" }
const _hoisted_26 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_27 = { class: "fv-row mb-10" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_editor = _resolveComponent("editor")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Documents = _resolveComponent("Documents")!
  const _component_DocumentsRO = _resolveComponent("DocumentsRO")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_editor, {
            for: "strategy",
            initialValue: "step1.strategy",
            modelValue: _ctx.step1.strategy,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step1.strategy) = $event)),
            licenseKey: "gpl",
            "api-key": _ctx.currentEditorToken,
            init: {
              height: 200,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap',
                'searchreplace visualblocks code fullscreen',
                'print preview anchor insertdatetime media',
                'paste code help wordcount table',
              ],
              toolbar:
                'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
            }
          }, null, 8, ["modelValue", "api-key"]),
          _createVNode(_component_Field, {
            type: "hidden",
            name: "strategy",
            class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
            modelValue: _ctx.step1.strategy,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step1.strategy) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_ErrorMessage, {
            name: "strategy",
            class: "fv-plugins-message-container invalid-feedback"
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("label", _hoisted_11, [
              _createVNode(_component_Field, {
                type: "checkbox",
                class: "form-check-input",
                name: "areChosenFromRecord",
                value: "1",
                modelValue: _ctx.step1.areChosenFromRecord,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step1.areChosenFromRecord) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.step1.areChosenFromRecord == "1" ? "Yes" : "No"), 1)
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_editor, {
              for: "approvedPerson",
              initialValue: "step1.approvedPerson",
              modelValue: _ctx.step1.approvedPerson,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step1.approvedPerson) = $event)),
              "api-key": _ctx.currentEditorToken,
              licenseKey: "gpl",
              init: {
                height: 200,
                menubar: false,
                plugins: [
                  'advlist autolink lists link image charmap',
                  'searchreplace visualblocks code fullscreen',
                  'print preview anchor insertdatetime media',
                  'paste code help wordcount table',
                ],
                toolbar:
                  'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
              }
            }, null, 8, ["modelValue", "api-key"]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "approvedPerson",
              class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
              placeholder: "How it will be record?",
              modelValue: _ctx.step1.approvedPerson,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step1.approvedPerson) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "approvedPerson",
              class: "fv-plugins-message-container invalid-feedback"
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("label", _hoisted_18, [
                _createVNode(_component_Field, {
                  type: "checkbox",
                  class: "form-check-input",
                  name: "hasIdentifiableInformation",
                  value: "1",
                  modelValue: _ctx.step1.hasIdentifiableInformation,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step1.hasIdentifiableInformation) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.step1.hasIdentifiableInformation == "1" ? "Yes" : "No"), 1)
              ])
            ])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_editor, {
                for: "identifiableInformation",
                initialValue: "step1.identifiableInformation",
                modelValue: _ctx.step1.identifiableInformation,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step1.identifiableInformation) = $event)),
                "api-key": _ctx.currentEditorToken,
                licenseKey: "gpl",
                init: {
                  height: 200,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap',
                    'searchreplace visualblocks code fullscreen',
                    'print preview anchor insertdatetime media',
                    'paste code help wordcount table',
                  ],
                  toolbar:
                    'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
                }
              }, null, 8, ["modelValue", "api-key"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "identifiableInformation",
                class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                placeholder: "How it will be record?",
                modelValue: _ctx.step1.identifiableInformation,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step1.identifiableInformation) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "identifiableInformation",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ])
          ], 512), [
            [_vShow, _ctx.step1.hasIdentifiableInformation === '1']
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("label", _hoisted_25, [
                _createVNode(_component_Field, {
                  type: "checkbox",
                  class: "form-check-input",
                  name: "hasAccess",
                  value: "1",
                  modelValue: _ctx.step1.hasAccess,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.step1.hasAccess) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.step1.hasAccess == "1" ? "No" : "Yes"), 1)
              ])
            ])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_Documents, {
                hiddeDocuments: "true",
                title: "Please attach a letter of approval from the organization or department from where the records will be obtained from.",
                option: "Approval Letter",
                classification: "Recruitment",
                optionTarget: "#kt_modal_upload_file4"
              }),
              _createVNode(_component_DocumentsRO, {
                title: "Approval Letter",
                option: "Approval Letter",
                hiddeDocuments: "false",
                classification: "Recruitment",
                optionTarget: "#kt_modal_upload_file4"
              })
            ])
          ], 512), [
            [_vShow, _ctx.step1.hasAccess === '1']
          ])
        ], 512), [
          [_vShow, _ctx.step1.areChosenFromRecord === '1']
        ])
      ])
    ])
  ]))
}